import CONSTANTS from '../constants'
import { downloadFile, getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { getConfigDetails } from '../../services/config'
import { addEventLog } from './EventsLog'

export const getFaciltyData = () => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_FACILTY_REQUEST })
    return getRequest(APICONFIG.getPartnerDetails).then((res) => {
        dispatch({ type: CONSTANTS.GET_FACILTY_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_FACILTY_FAILURE })
        return err
    })
}

// // Calls the API to get user token
// export const userDetails = (creds) => (dispatch) => {
//     dispatch({ type: CONSTANTS.USER_DETAILS_REQUEST })
//     return postRequest(APICONFIG.getUserDetailUrl, creds).then((res) => {
//         dispatch({ type: CONSTANTS.USER_DETAILS_SUCCESS, data: res })
//         return res
//     }).catch((err) => {
//         dispatch({ type: CONSTANTS.USER_DETAILS_FAILURE })
//         return err
//     })
// }
// Calls the API to get user token
export const userDetails = (creds) => (dispatch) => {
    dispatch({ type: CONSTANTS.USER_DETAILS_REQUEST })
    return postRequest(APICONFIG.getSearchUrl, creds).then((res) => {
        dispatch({ type: CONSTANTS.USER_DETAILS_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.USER_DETAILS_FAILURE })
        return err
    })
}

export const sendSmsEmail = (creds) => (dispatch) => {
    dispatch({ type: CONSTANTS.SMS_EMAIL_REQUEST })
    return postRequest(APICONFIG.sendSmsEmailUrl, creds).then((res) => {
        dispatch({ type: CONSTANTS.SMS_EMAIL_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.SMS_EMAIL_FAILURE })
        return err
    })
}

export const downloadTicket = (payload) => (dispatch) => {
    dispatch(addEventLog(payload, CONSTANTS.DOWNLOAD_TICKET_REQUEST))
    dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_REQUEST })
    let endpoint = `${APICONFIG.downloadEticketUrl}/${payload?.ticket_number}/${getConfigDetails()?.PARTNER_ID}`
    if(payload?.is_event && payload?.is_event == 1){
        endpoint = `${APICONFIG.downloadEventticketUrl}/${payload?.ticket_number}`
    }
    return downloadFile(endpoint, payload?.ticket_number, `${payload?.ticket_number ? payload?.ticket_number : 'ticket'}.pdf`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.DOWNLOAD_TICKET_SUCCESS))
        dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let resObject = { ...payload, ...err }
        dispatch(addEventLog(resObject, CONSTANTS.DOWNLOAD_TICKET_FAILURE))
        dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_FAILURE })
        return err
    })
}


// Calls the API to fetch Ticket Details
export const getTicketDetails = (payload) => (dispatch) => {
    const data = {...payload, 'device_type': 'web'}
    dispatch(addEventLog(data, CONSTANTS.GET_TICKET_DETAILS_REQUEST))
    dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_REQUEST })
    return postRequest(APICONFIG.getSearchTicketUrl, data).then((res) => {
        let resObject = { ...data, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_TICKET_DETAILS_SUCCESS))
        dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let resObject = { ...data, ...err }
        dispatch(addEventLog(resObject, CONSTANTS.GET_TICKET_DETAILS_FAILURE))
        dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_FAILURE, errorMessage: err?.errors?.message })
        return err
    })
}

// Calls the API to fetch Ticket Details
export const getTicketList = (payload, page = '') => (dispatch) => {
    const finalPayload = {
        payload: payload,
        page: page
    }
    dispatch(addEventLog(finalPayload, CONSTANTS.GET_TICKET_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_TICKET_LIST_REQUEST })
    let url = APICONFIG.getUserDetailUrl
    if(page){
        url = `${APICONFIG.getUserDetailUrl}?page=${page}`
    }

    return postRequest(url, payload).then((res) => {
        let resObject = { ...finalPayload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_TICKET_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.GET_TICKET_LIST_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let resObject = { ...finalPayload, ...err }
        dispatch(addEventLog(resObject, CONSTANTS.GET_TICKET_LIST_FAILURE))
        dispatch({ type: CONSTANTS.GET_TICKET_LIST_FAILURE, errorMessage: err?.errors?.message })
        return err
    })
}

// GET PARTNER BY SLUG
export const getPartnerDetailsBySLug = (slug) => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_REQUEST })
    return getRequest(`${APICONFIG.getPartnerBySlug}/${slug}`).then((res) => {
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_FAILURE, errorMessage: err })
        return err
    })
}

// GET THE TICKET DETAILS BY QR
export const getOfflineTicketDetailsQR = (payload) => (dispatch) => {
    dispatch(addEventLog(payload, CONSTANTS.GET_OFFLINE_TICKET_DETAILS_QR_REQUEST))
    dispatch({ type: CONSTANTS.GET_OFFLINE_TICKET_DETAILS_QR_REQUEST })
    let url = APICONFIG.getOfflineTicketDetails
    return postRequest(url, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_OFFLINE_TICKET_DETAILS_QR_SUCCESS))
        dispatch({ type: CONSTANTS.GET_OFFLINE_TICKET_DETAILS_QR_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let resObject = { ...payload, ...err }
        dispatch(addEventLog(resObject, CONSTANTS.GET_OFFLINE_TICKET_DETAILS_QR_FAILURE))
        dispatch({ type: CONSTANTS.GET_OFFLINE_TICKET_DETAILS_QR_FAILURE, errorMessage: err?.errors?.message })
        return err
    })
}